<template>
  <div v-show="position.showNav" class="dh-view">
    <div class="navIcon" @click="showMenu">
      <a-icon
        type="menu"
        :style="{
          color: `${option.iconColor}`,
          fontSize: `${option.iconFontSize}px`,
          transform: showNav ? ' rotate(-90deg)' : ''
        }"
      />
      <div :style="{ color: `${option.color}`, fontSize: `${option.fontSize}px` }">{{ showNav ? '收起' : '菜单' }}</div>
    </div>
    <div v-if="showNav" class="navcur  navshow">
      <span class="mldh">目录导航</span>
      <ul class="navpc">
        <li class="nav-1" v-for="item in option.mainMenuList" :key="item.iid">
          <a class="sjdj" target="_blank" :href="item.url">{{ item.title }}</a>
          <img
            style="position: absolute;right: 10px;top:10px;"
            src="./assets/jia.png"
            @click="handleNavShow(index)"
            v-show="item.subMenuList.length > 0"
            alt=""
          />
          <dl class="curdl" v-show="showChild">
            <dd class="childnav-1-1" v-for="subItem in item.subMenuList" :key="subItem.iid">
              <a :href="subItem.url" target="_blank"> {{ subItem.title }} </a>
            </dd>
          </dl>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  // 导航配置组件
  name: 'NavList',
  filters: {},
  components: {},
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showChild: false,
      showNav: false
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.showChild = this.option.showChild
  },
  methods: {
    handleNavShow() {
      this.showChild = !this.showChild
      this.$nextTick(() => {
        const iconHeight = document.querySelector('.navIcon').offsetHeight
        const menuHeight = document.querySelector('.navcur').offsetHeight
        this.position.h = iconHeight + menuHeight + 10
      })
    },
    showMenu() {
      this.showNav = !this.showNav
      if (this.showNav) {
        this.position.w = 240
        this.$nextTick(() => {
          const iconHeight = document.querySelector('.navIcon').offsetHeight
          const menuHeight = document.querySelector('.navcur').offsetHeight
          this.position.h = iconHeight + menuHeight + 10
        })
      } else {
        const iconHeight = document.querySelector('.navIcon').offsetHeight
        this.position.h = iconHeight
      }
    }
  }
}
</script>

<style scoped lang="less">
.dh-view {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 999;
}
.navshow {
  width: 240px;
}
.navcur {
  position: absolute;
  left: 0px;
  top: 75px;
  cursor: default;
  padding-bottom: 68px;
  overflow: hidden;
}
.mldh {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  background: #061e56 url('./assets/22.png') no-repeat;
  display: block;
  width: 130px;
  height: 49px;
  font-size: 22px;
  color: #acbfdb;
  font-weight: bold;
  line-height: 49px;
  text-align: center;
  z-index: 125;
}
.navpc {
  background: #061e56 url('./assets/77.png') repeat-y;
  position: relative;
  top: 55px;
  left: -1px;
  z-index: 120;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.1), 0 0px 4px #6ef0e0;
  &::before {
    position: relative;
    top: -31px;
    display: block;
    width: 240px;
    height: 31px;
    background: #061e56 url('./assets/66.png');
    content: '';
    filter: alpha(opacity=98);
    -moz-opacity: 0.98;
    -khtml-opacity: 0.98;
    opacity: 0.98;
  }
}
.navpc li {
  cursor: pointer;
  font-size: 18px;
  width: 178px;
  margin: 0 auto;
  background: url('./assets/11.png') no-repeat;
  line-height: 40px;
  color: #a7d7f7;
  text-align: center;
  margin-bottom: 20px;
  position: relative;
  top: -10px;
}
.navpc > li > a.sjdj {
  color: #57ffed;
  font-weight: bold;
  text-decoration: none;
}
.navpc li .jia {
  background: url('./assets/jia.png');
}
.navpc dl.curdl {
  display: block;
  margin: 0 auto;
}
.navpc dl dd {
  background: url('./assets/ddxhx.png') no-repeat bottom center;
  text-align: center;
  height: 43px;
  line-height: 43px;
  margin: 0;
  padding: 0;
}
.navpc dl dd a {
  font-size: 16px;
  color: #a7bad9;
}
.navpc a {
  display: block;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.navIcon {
  text-align: center;
  cursor: pointer;
  position: absolute;
}
</style>
